import type { Platform } from '@reelplicate/api-client/model';

/** Display names for the API's platforms. */
export const PLATFORM_LABELS: Record<Platform, string> = {
  TIKTOK: 'TikTok',
  INSTAGRAM: 'Instagram',
  YOUTUBE: 'YouTube',
  LINKEDIN: 'LinkedIn',
  FACEBOOK: 'Facebook',
};
